import SystemHealthContainer from "./SystemHealthContainer";

export default SystemHealthContainer;
